import { render, staticRenderFns } from "./Podio.vue?vue&type=template&id=231d446c&scoped=true&lang=pug&"
import script from "./Podio.vue?vue&type=script&lang=js&"
export * from "./Podio.vue?vue&type=script&lang=js&"
import style0 from "./Podio.vue?vue&type=style&index=0&id=231d446c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d446c",
  null
  
)

export default component.exports